import OlSelect from 'ol/interaction/Select';
import { useCallback } from 'react';
import useApplicationState from '../hooks/useApplicationState';
import { useOpenLayers } from '../react-ol';
import findFeatureInLayers from '../utils/findFeatureInLayers';
import findInteractions from '../utils/findInteractions';
import findLayers from '../utils/findLayers';

var useSetSelectedFeature = () => {
  var {
    map
  } = useOpenLayers();
  var {
    selectedFeatureRef
  } = useApplicationState();
  return useCallback(id => {
    if (map && selectedFeatureRef) {
      var layers = findLayers(map, l => l.get('canSelect'));

      if (layers.length > 0) {
        if (id) {
          var foundSelectedFeature = findFeatureInLayers(layers, id);

          if (foundSelectedFeature) {
            var selectInteraction = findInteractions(map, i => i instanceof OlSelect)[1];
            var previouslySelectedFeature = selectedFeatureRef.current || undefined;
            selectedFeatureRef.current = foundSelectedFeature;
            selectInteraction.dispatchEvent({
              type: 'select',
              selected: foundSelectedFeature ? [foundSelectedFeature] : [],
              deselected: previouslySelectedFeature ? [previouslySelectedFeature] : []
            });
          } else console.warn("Could not find feature with ID: ".concat(id));
        } else console.warn("Could not select feature. SetSelectedFeature was not passed a feature ID to search for");
      } else console.warn("Could not select feature. Could not find a layer with 'canSelect' prop.");
    }
  }, [map, selectedFeatureRef]);
};

export default useSetSelectedFeature;